/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown>, pct: NonNullable<unknown> }} Wrapped_Period_Volume_UpInputs */

const en_us2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% above the month before.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% above the year before.`)
	
};

const pt_br2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% acima do mês anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% acima do ano anterior.`)
	
};

const es_419_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% por encima del mes anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% por encima del año anterior.`)
	
};

const pt_pt2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% acima do mês anterior.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% acima do ano anterior.`)
	
};

const fr_fr2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct} % de plus que le mois précédent.`);
	return /** @type {LocalizedString} */ (`${i?.pct} % de plus que l'année précédente.`)
	
};

const de_de2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% über dem Vormonat.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% über dem Vorjahr.`)
	
};

const it_it2_wrapped_period_volume_up = /** @type {(inputs: Wrapped_Period_Volume_UpInputs) => LocalizedString} */ (i) => {
	if (i?.period === "month") return /** @type {LocalizedString} */ (`${i?.pct}% in più rispetto al mese precedente.`);
	return /** @type {LocalizedString} */ (`${i?.pct}% in più rispetto all'anno precedente.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "month" | "{pct}% above the month before." |
* | * | "{pct}% above the year before." |
*
* @param {Wrapped_Period_Volume_UpInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_volume_up = /** @type {((inputs: Wrapped_Period_Volume_UpInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Volume_UpInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_volume_up(inputs)
	if (locale === "es-419") return es_419_wrapped_period_volume_up(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_volume_up(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_volume_up(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_volume_up(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_volume_up(inputs)
	return en_us2_wrapped_period_volume_up(inputs)
});
export { wrapped_period_volume_up as "wrapped-period.volume_up" }